import React from 'react';
import { CheckCircleIcon, AwardIcon, StarIcon, ShieldIcon, UsersIcon, BadgeCheckIcon } from 'lucide-react';
export const CredibilityBadges = () => {
  return <section className="w-full bg-white py-12 md:py-16" id="how-it-works" data-id="element-129">
      <div className="container mx-auto px-4 md:px-6" data-id="element-130">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-12" data-id="element-131">
          Trusted by sleep experts. Loved by real people.
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 text-center" data-id="element-132">
          <div className="bg-indigo-50 rounded-lg p-4 flex flex-col items-center" data-id="element-133">
            <CheckCircleIcon className="h-8 w-8 text-indigo-600 mb-2" data-id="element-134" />
            <p className="font-medium text-gray-800" data-id="element-135">
              Clinically Studied Formula
            </p>
          </div>
          <div className="bg-indigo-50 rounded-lg p-4 flex flex-col items-center" data-id="element-136">
            <ShieldIcon className="h-8 w-8 text-indigo-600 mb-2" data-id="element-137" />
            <p className="font-medium text-gray-800" data-id="element-138">Non-Habit Forming</p>
          </div>
          <div className="bg-indigo-50 rounded-lg p-4 flex flex-col items-center" data-id="element-139">
            <BadgeCheckIcon className="h-8 w-8 text-indigo-600 mb-2" data-id="element-140" />
            <p className="font-medium text-gray-800" data-id="element-141">Backed by Sleep Experts</p>
          </div>
          <div className="bg-indigo-50 rounded-lg p-4 flex flex-col items-center" data-id="element-142">
            <UsersIcon className="h-8 w-8 text-indigo-600 mb-2" data-id="element-143" />
            <p className="font-medium text-gray-800" data-id="element-144">
              4,00,000+ Happy Customers
            </p>
          </div>
          <div className="bg-indigo-50 rounded-lg p-4 flex flex-col items-center" data-id="element-145">
            <StarIcon className="h-8 w-8 text-indigo-600 mb-2" data-id="element-146" />
            <p className="font-medium text-gray-800" data-id="element-147">5-Star Reviews</p>
          </div>
          <div className="bg-indigo-50 rounded-lg p-4 flex flex-col items-center" data-id="element-148">
            <AwardIcon className="h-8 w-8 text-indigo-600 mb-2" data-id="element-149" />
            <p className="font-medium text-gray-800" data-id="element-150">
              30-Day Money-Back Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
};